import apiService from './ApiService';
import { isInstitutionalAssistantType } from '../utils/asistenteTypes';

class AdminAsistenteService {
  async getAsistentes(options = {}) {
    const params = new URLSearchParams();
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    const qs = params.toString();
    const response = await apiService.get(`/asistente${qs ? `?${qs}` : ''}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener los asistentes.';
      throw new Error(msg);
    }
    const list = response?.asistentes || response?.Asistentes || response?.data || response || [];
    const items = Array.isArray(list) ? list : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async refrescarEstadosRagFlow(idRegional = null) {
    const qs = idRegional ? `?idRegional=${encodeURIComponent(idRegional)}` : '';
    const response = await apiService.request(`/asistente/ragflow/refrescar-estados${qs}`, {
      method: 'POST'
    });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos refrescar los estados AVE.';
      throw new Error(msg);
    }
    return response;
  }

  async getAsistenteById(idOpenAIAssistant) {
    if (!idOpenAIAssistant) throw new Error('Falta el identificador del asistente.');
    const response = await apiService.get(`/asistente/${idOpenAIAssistant}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos obtener el asistente.';
      throw new Error(msg);
    }
    const data = response?.asistente || response?.Asistente;
    return data || response;
  }

  async createAsistente(payload = {}) {
    if (!payload.nombre) throw new Error('Completa el nombre del asistente.');
    if (!payload.idTipoAsistente) throw new Error('Selecciona el tipo de asistente.');
    if (!payload.idArea) throw new Error('Selecciona el área.');
    if (!payload.idRegional) throw new Error('Falta el regional.');
    if (!payload.idMateria && !isInstitutionalAssistantType({ id: payload.idTipoAsistente })) {
      throw new Error('Selecciona una materia para asistentes de grado o electiva.');
    }
    if (isInstitutionalAssistantType({ id: payload.idTipoAsistente }) && !String(payload.instruccionesInstitucionales || '').trim()) {
      throw new Error('Completa las instrucciones del asistente institucional.');
    }

    const response = await apiService.post('/asistente', payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear el asistente.';
      throw new Error(msg);
    }
    return response;
  }

  async updateAsistente(idOpenAIAssistant, payload = {}) {
    if (!idOpenAIAssistant) throw new Error('Falta el identificador del asistente.');
    if (!payload.nombre) throw new Error('Completa el nombre del asistente.');
    if (!payload.idTipoAsistente) throw new Error('Selecciona el tipo de asistente.');
    if (!payload.idArea) throw new Error('Selecciona el área.');
    if (!payload.idRegional) throw new Error('Falta el regional.');
    if (!payload.idMateria && !isInstitutionalAssistantType({ id: payload.idTipoAsistente })) {
      throw new Error('Selecciona una materia para asistentes de grado o electiva.');
    }
    if (isInstitutionalAssistantType({ id: payload.idTipoAsistente }) && !String(payload.instruccionesInstitucionales || '').trim()) {
      throw new Error('Completa las instrucciones del asistente institucional.');
    }

    const response = await apiService.put(`/asistente/${idOpenAIAssistant}`, payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el asistente.';
      throw new Error(msg);
    }
    return response;
  }

  async updateAsistenteActivo(idOpenAIAssistant, activo) {
    if (!idOpenAIAssistant) throw new Error('Falta el identificador del asistente.');
    const response = await apiService.put(`/asistente/${idOpenAIAssistant}/activo`, { activo });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos cambiar el estado del asistente.';
      throw new Error(msg);
    }
    return response;
  }
}

const adminAsistenteService = new AdminAsistenteService();

export default adminAsistenteService;
